import { render, staticRenderFns } from "./coach-requests.vue?vue&type=template&id=c01ad4dc&"
import script from "./coach-requests.vue?vue&type=script&lang=js&"
export * from "./coach-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports